export enum IEProvinceCode {
  Carlow = 'CW',
  Cavan = 'CN',
  Clare = 'CE',
  Cork = 'CK',
  Donegal = 'DL',
  Dublin = 'DN',
  Galway = 'GY',
  Kerry = 'KY',
  Kildare = 'KE',
  Kilkenny = 'KK',
  Laois = 'LS',
  Leitrim = 'LM',
  Limerick = 'LK',
  Longford = 'LD',
  Louth = 'LH',
  Mayo = 'MO',
  Meath = 'MH',
  Monaghan = 'MN',
  Offaly = 'OY',
  Roscommon = 'RN',
  Sligo = 'SO',
  Tipperary = 'TY',
  Waterford = 'WD',
  Westmeath = 'WH',
  Wexford = 'WX',
  Wicklow = 'WW',
}
